export enum ClientBillType {
  monthly = 'monthly',
  installation = 'installation',
}

export namespace ClientBillType {
  export const translateType = (type: ClientBillType): string => {
    switch (type) {
      case ClientBillType.monthly:
        return "Mensalidade";
      case ClientBillType.installation:
        return "Instalação";
      default:
        return "";
    }
  };

  export const ClientBillTypeChoices = Object.values(ClientBillType)
  .filter((x): x is ClientBillType => typeof x === "string")
  .map(type => {
    return ({
      id: type,
      name: ClientBillType.translateType(type)
    });
  });
}
